import { __rest, __assign } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import assert from 'assert';
import { Children } from 'react';
import flattenChildren from 'react-keyed-flatten-children';
import { Box } from '../Box/index.js';

var validInlineComponents = ["div", "span", "ol", "ul"];
var verticalAlignMap = {
    top: "flex-start",
    center: "center",
    bottom: "flex-end",
};
var horizontalAlignMap = {
    left: "flex-start",
    center: "center",
    right: "flex-end",
    apart: "space-between",
};
var horizontalAlignment = function (alignX, reverse) {
    if (reverse && alignX === "right")
        return "flex-start";
    if (reverse && alignX === "left")
        return "flex-end";
    return horizontalAlignMap[alignX];
};
var Inline = function (_a) {
    var children = _a.children, _b = _a.component, component = _b === void 0 ? "div" : _b, _c = _a.gap, gap = _c === void 0 ? "0" : _c, _d = _a.alignY, alignY = _d === void 0 ? "center" : _d, _e = _a.alignX, alignX = _e === void 0 ? "left" : _e, _f = _a.reverse, reverse = _f === void 0 ? false : _f, noWrap = _a.noWrap, props = __rest(_a, ["children", "component", "gap", "alignY", "alignX", "reverse", "noWrap"]);
    assert(validInlineComponents.includes(component), "Invalid Inline component: '".concat(component, "'. Should be one of [").concat(validInlineComponents
        .map(function (c) { return "'".concat(c, "'"); })
        .join(", "), "]"));
    var isList = component === "ol" || component === "ul";
    var inlineItemComponent = isList ? "li" : component;
    return (jsx(Box, __assign({ component: component, sx: {
            display: "flex",
            gap: gap,
            alignItems: verticalAlignMap[alignY],
            justifyContent: horizontalAlignment(alignX, reverse),
            flexWrap: noWrap ? "nowrap" : "wrap",
            flexDirection: reverse ? "row-reverse" : "row",
            listStyle: "none",
            margin: 0,
            padding: 0,
        } }, props, { children: Children.map(flattenChildren(children), function (child) {
            return child !== null && child !== undefined ? (jsx(Box, __assign({ component: inlineItemComponent, sx: { display: "flex", justifyContent: "center" } }, { children: child }))) : null;
        }) })));
};

export { Inline, Inline as default };
//# sourceMappingURL=Inline.js.map
